import React, { useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome';
import { useDispatch, useSelector } from 'react-redux';

import { Colors } from 'react-native-paper';
import { AppHeader, Loader } from '../../../components/common';
import { AppButton, AppInput, AppText } from '../../../components/form';
import { pixelDimensions } from '../../../config/utils';
import { rateClass } from '../../../redux/actions/workerActions';
import styles from './styles';

const onlineGymEvaluation = ({ navigation, route }) => {
  const { workerData, isLoading } = useSelector((state) => state.worker);
  const { id_colaborador } = workerData;
  const { id_aula, moedas } = route.params;
  const [rateData, changeRateData] = useState({
    pStars: 0,
    pText: '',
    aStars: 0,
    aText: '',
  });
  const renderStars = (stars, type) => {
    const final = [];
    for (let i = 0; i < 5; i++) {
      final.push(i < stars ? '+' : '-');
    }
    const key = type === 1 ? 'pStars' : 'aStars';
    return (
      <View style={styles.viewStars}>
        {final.map((item, index) => (
          <TouchableOpacity key={`star-${type}-${index}`} onPress={() => changeRateData({ ...rateData, [key]: index + 1 })}>
            <Icon name={`star${item === '-' ? '-o' : ''}`} style={{ fontSize: pixelDimensions(17), color: item === '+' ? Colors.yellow500 : Colors.black, paddingRight: pixelDimensions(2) }} />
          </TouchableOpacity>
        ))}
      </View>
    );
  };
  const dispatch = useDispatch();
  const handleConfirmEvaluation = () => {
    dispatch(rateClass({
      id_aula, id_colaborador, moedas, saldo: workerData.saldo_moedas, ...rateData,
    }, navigation));
    // () => navigation.navigate('Worker Profile')
  };
  return (
    <View style={styles.viewBase}>
      {isLoading && <Loader onTop />}
      <AppHeader title="Avaliar Aula" />
      <View style={styles.content}>
        <AppText size="bold" style={styles.textTitle}>PROFISSIONAL</AppText>
        { renderStars(rateData.pStars, 1) }
        <AppInput value={rateData.pText} onChangeText={(newValue) => changeRateData({ ...rateData, pText: newValue })} style={styles.input} placeholder="Qual a sua sugestão para melhorar?" />
        <AppText size="bold" style={styles.textTitle}>AULA</AppText>
        { renderStars(rateData.aStars, 2) }
        <AppInput value={rateData.aText} onChangeText={(newValue) => changeRateData({ ...rateData, aText: newValue })} style={styles.input} placeholder="Qual a sua sugestão para melhorar?" />
        <AppText style={styles.textSubTitle}>Após avaliação será confirmada sua presença na aula</AppText>
        <AppButton size="bold" label="CONFIRMAR" style={styles.buttonBack} labelStyle={styles.textBack} onPress={handleConfirmEvaluation} />
      </View>
    </View>
  );
};

export default onlineGymEvaluation;
